<body>
<div class="col-12 col-sm-12 col-md-12 col-lg-12 boxstyle">
    <div class="conclass-contact pt-4">
        <div class="row">
            <div class="col-3 col-sm-3 col-md-1 col-lg-1 text-center">
                 <img src="./assets/images/backarrow.png" (click)="back()" alt="" class="imgstyle cp">
            </div>
            <div class="col-9 col-sm-9 col-md-11 col-lg-11">
                 <label  class="textcontact regular fs-20">Contact Us</label>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-5 p-4">
                <div class="box1">
                    <h1 class="boxhead">Travelance and MyTL Support Services</h1>
                    <div class="clear20"></div>
                    <label class="fs-14 regular support-servicetxt">Support Services </label>
                   
                    <p class="fs-14 regular">Monday - Friday 9:00 a.m. - 7:00 p.m. ET </p>
                     <div class="clear10"></div>
                     <p class="fs-14">Phone: <b><a href="tel:1-855-566-8555">1-855-566-8555</a> Ext: 1</b> </p>
                     <p class="fs-14">Email: <b><a href="mailto:info@travelance.ca">info@travelance.ca</a></b></p>
 
                     <hr>
                     <label class="fs-14 regular support-servicetxt"> Compliance/Contracting Services </label>
                   
                    <p class="fs-14 regular">Monday - Friday 9:00 a.m. - 7:00 p.m. ET  </p>
                     <div class="clear10"></div>
                     <p class="fs-14">Phone: <b><a href="tel:1-855-566-8555">1-855-566-8555</a> Ext: 3</b> </p>
                     <p class="fs-14">Email: <b><a href="mailto:join@travelance.ca">join@travelance.ca</a></b></p>
 
                     <hr>
                     <label class="fs-14 regular support-servicetxt">Mailing Address </label>
                   
                 <p class="bold fs-14">Travelance Inc. </p>
                     
                     
                <p class="regular fs-14"> 126 Catharine St. N.</p>  
                <p class="regular fs-14"> Hamilton, ON</p>
                <p class="regular fs-14">L8R 1J4</p>
                
                    <div class="clear10"></div>
                    <hr>
                 <p class="fs-14 regular support-servicetxt">Website</p>
                 <p class="fs-14 bold webtext"><a href="https://www.travelance.ca/" target="_blank">www.travelance.ca</a></p>
                    
                </div> 
                <div class="clear20"></div>
                <div class="box1">
                    <h1 class="boxhead">International Student Travel Insurance Policy (ISP) Claims</h1>
                    <div class="clear20"></div>
                    <label class="fs-14 regular support-servicetxt">Contact Information To Report a Claim</label>                   
                    <p class="fs-14">Toll-free From Canada or USA: <b><a class="bold" href="tel:1-833-515-3317">1-833-515-3317</a></b></p>
                    <p class="fs-14">Collect Worldwide: <b><a class="bold" href="tel:1-416-479-8007">1-416-479-8007</a></b></p>
                    <p class="fs-14 regular">Email: <b><a class="bold" href="mailto:travelclaims@wtp.ca">travelclaims@wtp.ca</a></b></p>
                     <hr>
                     <label class="fs-14 regular support-servicetxt">Mailing Address </label>
                    <p class="bold fs-14">Zurich Canada Travel Insurance</p>
                    <p class="regular fs-14">c/o Zurich Travel Assist</p>  
                    <p class="regular fs-14">Suite 300, 901 King St. W.</p>
                    <p class="regular fs-14">Toronto, Ontario</p>
                    <p class="regular fs-14">M5V 3H5</p>        
                </div> 
            </div>
           
 
            <div class="col-lg-5 p-4">
             <div class="box1">
                 <h1 class="boxhead">For VTC, TRIPs and SAP Claims and Sales Portal</h1>
                 <div class="clear20"></div>
                 <label class="fs-14 regular support-servicetxt">Policy Administration Inquiries</label>
                
                 <p class="fs-14 regular">Monday - Friday 9:00 a.m. - 7:00 p.m. ET </p>
                  <div class="clear10"></div>
                  <p class="fs-14">Phone: <b><a href="tel:855-566-8555">855-566-8555</a> Ext: 1</b> </p>
                  <p class="fs-14 regular">Fax:<b> 888-882-3004</b></p>
                  <p class="fs-14">Email: <b><a href="mailto:info@travelance.ca">info@travelance.ca</a></b></p>
 
                  <hr>
   
 
                  <label class="fs-14 regular support-servicetxt"> Claim Inquiries </label>
                
                 <p class="fs-14 regular"> Monday - Friday 8:30 a.m. - 8:00 p.m. ET  </p>
                  <div class="clear10"></div>
                  <p class="fs-14">Phone: <b><a href="tel:888-526-0111">888-526-0111</a> Ext: 2</b> </p>
                  <p class="fs-14 regular">Fax:<b> 866-551-1704</b></p>
                  <p class="fs-14">Email: <b><a href="mailto:traveladmin@getreliable.com">traveladmin@getreliable.com</a></b></p>
 
                  <hr>
 
                  
                 
 
                  <label class="fs-14 regular support-servicetxt">Sales Portal Technical Support </label>
 
                  <p class="fs-14 regular">  Monday - Friday 8:00 a.m. - 11:00 p.m. ET and <br>  Saturday 9:00 a.m. - 5:00 p.m. ET </p>
                  <div class="clear10"></div>
                  <p class="fs-14">Phone: <b><a href="tel:1-855-566-8555">1-855-566-8555</a> Ext: 4</b></p>
                  
                
 
                  <hr>
                  <label class="fs-14 regular support-servicetxt">Mailing Address </label>
                   
                  <p class="bold fs-14">Old Republic Insurance Company of Canada</p>
                      
                   
                 <p class="regular fs-14"> PO Box 557, 100 King St. W.</p>  
                 <p class="regular fs-14">  Hamilton, ON</p>
                 <p class="regular fs-14">  L8N 3K9</p>
                 
 
 
 
 
                
             
                 
             </div> 
            </div>
        </div>
    </div>
    <div class="clear50"></div>
</div>
</body>